<template>
  <p v-if="error" class="error--text mt-1" :style="errorMessageStyles">
    {{ error }}
  </p>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import THEME from "constants/theme"

export default defineComponent({
  name: "PostFormError",
  props: {
    error: {
      type: String,
      default: null,
    },
  },
  setup() {
    const errorMessageStyles = {
      ...THEME.typography.inputMessage,
    }
    return {
      errorMessageStyles,
    }
  },
})
</script>
